import _descriptors from "../internals/descriptors";
import _functionUncurryThis from "../internals/function-uncurry-this";
import _defineBuiltInAccessor from "../internals/define-built-in-accessor";
var DESCRIPTORS = _descriptors;
var uncurryThis = _functionUncurryThis;
var defineBuiltInAccessor = _defineBuiltInAccessor;
var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !("size" in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, "size", {
    get: function size() {
      var count = 0;
      forEach(this, function () {
        count++;
      });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}
export default {};